import React from "react";
import Label from './LabelUtilsComponet'
import Required from './RequiredComponent'

const Checkbox = ({ config, onChange }) => {
  return (
    <div className={config.classContainer}>
      <Label {...config} />
      <div className="div-checkbox-form">
        {config.data.map((item, index) => {
          return (
            <div
              key={`ckb_${config.variable}_${index}`}
              className={config.classInput}
              onClick={() => onChange(config.variable, item[config.keyValue], config.type)}
            >
              {
                config.value.includes(item[config.keyValue]) ?
                  <i className="far fa-check-square fa-1x5"></i> :
                  <i className="far fa-square fa-1x5"></i>
              }
              &nbsp;{item[config.keyText]}
            </div>
          );
        })}
      </div>
        {
          <Required {...config} msg="Seleccione al menos un elemento" />
        }
    </div>
  )
}

export default Checkbox;
